import { attachErrorCodeDomain } from "./i18n-error-code-common";
import { errorCodeDomain as zhErrorCodes } from "./i18n/features/zh/error-code-edu";
import { errorCodeDomain as enErrorCodes } from "./i18n/features/en/error-code-edu";
import { errorCodeDomain as jaErrorCodes } from "./i18n/features/ja/error-code-edu";

import { common as zhCommon } from "./i18n/common";
import { commonCatalog as enCommon } from "./i18n/features/en/common";
import { commonCatalog as jaCommon } from "./i18n/features/ja/common";
import { platformAdmin as enPlatformAdmin } from "./i18n/features/en/platform-admin";
import { platformAdmin as jaPlatformAdmin } from "./i18n/features/ja/platform-admin";
import { platformAdmin as zhPlatformAdmin } from "./i18n/features/zh/platform-admin";
import {
  APP_LOCALE_LABELS,
  APP_LOCALES,
  DEFAULT_LOCALE,
  getLocale as sharedGetLocale,
  normalizeLocale,
  setLocale as sharedSetLocale,
  subscribeLocaleChange as sharedSubscribeLocaleChange,
} from "./i18n/locale-state";
import { createI18nRuntime } from "./i18n/runtime";

export type { AppLocale } from "./i18n/locale-state";
export { APP_LOCALE_LABELS, APP_LOCALES, DEFAULT_LOCALE, normalizeLocale } from "./i18n/locale-state";

// EDU admin is its own product shell: it needs the shared common catalog plus
// the platform admin site title used by every admin document title, not the
// full platform admin console catalog.
const localeCatalogs = {
  "zh-CN": { common: zhCommon, platform: { admin: { title: zhPlatformAdmin.title } } },
  en: { common: enCommon, platform: { admin: { title: enPlatformAdmin.title } } },
  ja: { common: jaCommon, platform: { admin: { title: jaPlatformAdmin.title } } },
} as const;

export const {
  messageCatalogs,
  setLocale,
  getLocale,
  subscribeLocaleChange,
  createMessageProxy,
  hasMessage,
  t,
  formatMessage,
  formatEnumPath,
  formatEnumLabel,
  formatBooleanLabel,
  formatLocalizedList,
  formatActionObjectLabel,
  formatActionObjectMessage,
  formatActionObjectIntlLabel,
} = createI18nRuntime({
  defaultLocale: DEFAULT_LOCALE,
  localeCatalogs,
  normalizeLocale,
  localeState: {
    getLocale: sharedGetLocale,
    setLocale: sharedSetLocale,
    subscribeLocaleChange: sharedSubscribeLocaleChange,
  },
});

export type {
  DeepPartialMessageTree,
  FormatMessageLike,
  MessageDescriptor,
  MessageParams,
  MessageTree,
} from "./i18n/runtime";

// Error codes are app-owned: attach exactly the domain this transport renders.
attachErrorCodeDomain("edu", {
  "zh-CN": zhErrorCodes,
  en: enErrorCodes,
  ja: jaErrorCodes,
});
